module.exports = __webpack_public_path__ + "img/rwanga-logo.36fd896a.png";